import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './listas.module.css';
import { useModal } from '../../contexts/ModalContext';

const ListasPage = () => {
  const navigate = useNavigate();
  const { openModal } = useModal();
  const userRole = localStorage.getItem("userRole") || "ROLE_USER";

  const handleListaClick = (listType) => {
    openModal("ListasModal", { listType });
  };

  // Configuración de las secciones de listas según permisos
  const listasGestion = [
    {
      id: 'expedientes',
      title: 'Expedientes',
      description: 'Listado de expedientes con filtros personalizables',
      icon: 'file',
      roles: ['ROLE_USER', 'ROLE_MANAGER', 'ROLE_ADMIN']
    },
    {
      id: 'fechaParte',
      title: 'Fecha Parte Operarios',
      description: 'Control de partes de trabajo por operario',
      icon: 'calendar',
      roles: ['ROLE_USER', 'ROLE_MANAGER', 'ROLE_ADMIN']
    }
  ];

  const listasTecnicas = [
    {
      id: 'resumenPagoOperario',
      title: 'Resumen Pagos por Operario',
      description: 'Resumen de pagos realizados a operarios',
      icon: 'user',
      roles: ['ROLE_MANAGER', 'ROLE_ADMIN']
    },
    {
      id: 'costeReparadores',
      title: 'Listado Coste Reparadores',
      description: 'Costes asociados a reparadores',
      icon: 'stats',
      roles: ['ROLE_MANAGER', 'ROLE_ADMIN']
    }
  ];

  const listasAdministracion = [
    {
      id: 'margenBruto',
      title: 'Margen Bruto',
      description: 'Análisis de margen bruto por expediente',
      icon: 'stats',
      roles: ['ROLE_MANAGER', 'ROLE_ADMIN']
    },
    {
      id: 'facturasPendienteCobro',
      title: 'Facturas Pendiente de Cobro',
      description: 'Facturas emitidas pendientes de cobro',
      icon: 'file',
      roles: ['ROLE_USER', 'ROLE_MANAGER', 'ROLE_ADMIN']
    },
    {
      id: 'ratioFacturasPendienteCobro',
      title: 'Ratio Facturas Pendientes de Cobro',
      description: 'Ratio de facturas pendientes respecto al total',
      icon: 'stats',
      roles: ['ROLE_MANAGER', 'ROLE_ADMIN']
    },
    {
      id: 'facturasCobradas',
      title: 'Facturas Cobradas',
      description: 'Listado de facturas cobradas',
      icon: 'file',
      roles: ['ROLE_MANAGER', 'ROLE_ADMIN']
    },
    {
      id: 'resumenFacturacionAnual',
      title: 'Resumen Facturación Anual Compañías',
      description: 'Resumen anual de facturación por compañía',
      icon: 'stats',
      roles: ['ROLE_MANAGER', 'ROLE_ADMIN']
    },
    {
      id: 'facturacionMensual',
      title: 'Facturación Mensual',
      description: 'Desglose mensual de facturación',
      icon: 'calendar',
      roles: ['ROLE_MANAGER', 'ROLE_ADMIN']
    },
    {
      id: 'facturacionIva',
      title: 'Listado de Facturas por IVA',
      description: 'Facturas clasificadas por tipo de IVA',
      icon: 'file',
      roles: ['ROLE_MANAGER', 'ROLE_ADMIN']
    },
    {
      id: 'facturacion',
      title: 'Listado de Facturas',
      description: 'Listado completo de facturas',
      icon: 'file',
      roles: ['ROLE_MANAGER', 'ROLE_ADMIN']
    },
    {
      id: 'prefacturas',
      title: 'Listado de Pre-facturas',
      description: 'Listado de pre-facturas emitidas',
      icon: 'file',
      roles: ['ROLE_MANAGER', 'ROLE_ADMIN']
    },
    {
      id: 'listado347',
      title: 'Listado 347',
      description: 'Listado 347 para declaración trimestral',
      icon: 'file',
      roles: ['ROLE_MANAGER', 'ROLE_ADMIN']
    },
    {
      id: 'honorariosComerciales',
      title: 'Honorarios Comerciales',
      description: 'Honorarios de comerciales (3%)',
      icon: 'user',
      roles: ['ROLE_ADMIN'] // Solo ADMIN
    },
    {
      id: 'costeSinFactura',
      title: 'Expedientes con Coste y Sin Factura',
      description: 'Expedientes que tienen coste registrado pero no tienen factura emitida',
      icon: 'file',
      roles: ['ROLE_USER', 'ROLE_MANAGER', 'ROLE_ADMIN']
    }
  ];

  const hasAccess = (roles) => {
    return roles.includes(userRole);
  };

  const renderListCard = (lista) => {
    if (!hasAccess(lista.roles)) return null;

    return (
      <div
        key={lista.id}
        className={styles.listCard}
        onClick={() => handleListaClick(lista.id)}
      >
        <div className={styles.listContent}>
          <h3 className={styles.listTitle}>{lista.title}</h3>
          <p className={styles.listDescription}>{lista.description}</p>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Listas y Reportes</h1>
        <p className={styles.subtitle}>
          Accede a los diferentes listados y reportes del sistema
        </p>
      </div>

      <div className={styles.content}>
        {/* Dos columnas superiores */}
        <div className={styles.twoColumnGrid}>
          {/* Listados Gestión */}
          {listasGestion.some(l => hasAccess(l.roles)) && (
            <section className={styles.section}>
              <div className={styles.sectionHeader}>
                <h2 className={styles.sectionTitle}>Listados Gestión</h2>
                <p className={styles.sectionDescription}>
                  Listados básicos para la gestión diaria
                </p>
              </div>
              <div className={styles.listGrid}>
                {listasGestion.map(renderListCard)}
              </div>
            </section>
          )}

          {/* Listados Técnicos */}
          {(userRole === 'ROLE_MANAGER' || userRole === 'ROLE_ADMIN') && (
            <section className={styles.section}>
              <div className={styles.sectionHeader}>
                <h2 className={styles.sectionTitle}>Listados Técnicos</h2>
                <p className={styles.sectionDescription}>
                  Información técnica y de operaciones
                </p>
              </div>
              <div className={styles.listGrid}>
                {listasTecnicas.map(renderListCard)}
              </div>
            </section>
          )}
        </div>

        {/* Listados Administración - Ancho completo debajo */}
        {listasAdministracion.some(l => hasAccess(l.roles)) && (
          <section className={styles.section}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>Listados Administración</h2>
              <p className={styles.sectionDescription}>
                Reportes administrativos y financieros
              </p>
            </div>
            <div className={styles.listGrid}>
              {listasAdministracion.map(renderListCard)}
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

export default ListasPage;
